/* script */
//
//
//
//
//
//
//
//

import FileDropper from './FileDropper.vue';

const __vue_script__ = {
    name: 'ExcelImportFileDropper',

    components: {
        FileDropper
    },

    props: {
        eventId: {
            type: String,
            required: true
        },
        importType: {
            type: String,
            required: true
        }
    },

    methods: {
        async onFileSelected([file]) {
            try {
                const { jobId } = await this.startImport(file);
                await this.waitForImportToComplete(jobId);
            } catch (err) {
                // Ignore. Logged in each individual method.
            }
        },

        async startImport(file) {
            try {
                const { jobId, jobDocId } = await this.$services.excel.import(this.eventId, file, this.importType);
                this.$emit('import-start');
                return { jobId, jobDocId };
            } catch (err) {
                console.error('[ExcelImportFileDropper] Failed to import Excel file', err);
                this.$emit('import-start-failure');
                throw err;
            }
        },

        async waitForImportToComplete(jobId) {
            try {
                const result = await this.$services.jobs.waitFor({
                    jobId,
                    statusPath: this.$const.QUEUE_JOB_STATUS_PATH.replace('{{jobId}}', jobId.toString()),
                    resultPath: this.$const.QUEUE_JOB_RESULT_PATH.replace('{{jobId}}', jobId.toString())
                });
                const results = result?.results;
                console.debug('[ExcelImportFileDropper] Import finished', results);
                if (!results?.success) {
                    this.$emit('import-failure', results?.results || result);
                    return;
                }
                this.$emit('import-end', results);
            } catch (err) {
                console.error('[ExcelImportFileDropper] Import failed', err);
                this.$emit('import-failure');
                throw err;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-dropper',{attrs:{"supported-mimes":['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],"multiple":false},on:{"input":_vm.onFileSelected}})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ExcelImportFileDropper.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__